import React, { useState } from "react"
import { Pressable, View } from "react-native"

import styled from "styled-components/native"

import icons from "@treefort/tokens/app/icons"

import Icon from "./icon"
import { useTokens } from "./tokens-provider"

const StyledPressable = styled(Pressable)`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ExpandableContentContainer = styled.View`
  margin-top: ${({ theme }) => theme.spacing.xsmall}px;
  margin-bottom: ${({ theme }) => theme.spacing.tiny}px;
  margin-left: ${({ theme }) => theme.spacing.medium}px;
  border-radius: ${({ theme }) => theme.borderRadius.rounded}px;
  background-color: ${({ theme }) => theme.colors.background.secondary};
  padding: ${({ theme }) => theme.spacing.xsmall}px;
`

const HeaderContent = styled.View`
  flex: 1;
`

export default function ExpandableInfo({
  headerContent,
  children,
}: {
  headerContent: React.JSX.Element
  children: React.ReactNode
}): React.JSX.Element {
  const { tokens } = useTokens()
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <View>
      <StyledPressable onPress={() => setIsExpanded(!isExpanded)}>
        <Icon
          size="small"
          source={isExpanded ? icons.chevronDown : icons.chevronRight}
          color={tokens.colors.text.secondary}
        />
        <HeaderContent>{headerContent}</HeaderContent>
      </StyledPressable>
      {isExpanded ? (
        <ExpandableContentContainer>{children}</ExpandableContentContainer>
      ) : null}
    </View>
  )
}
